import { Form, Formik } from "formik";
import React from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { forgotPassword } from "../../actions/authAction";
import FormikControl from "../../components/WraapperComponent/FormikControl";
import history from "../../utils/history";

const ForgotLogin = () => {
  const initialValues = {
    email: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string().required("Required"),
  });

  const dispatch = useDispatch();

  const onSubmit = (values) => {
    const params = {
      username: values.email,
      action: "forgotPassword",
    };
    dispatch(
      forgotPassword(
        {
          params,
        },
        () => {
          history.push("/login");
        }
      )
    );
  };

  return (
    <div className="login-container mt-4">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formik) => {
          return (
            <Form>
              <FormikControl
                control="input"
                type="text"
                label="Enter Email or username"
                placeholder="Enter your Email Address or Username"
                name="email"
                hasError={formik.errors.email && formik.touched.email}
              />

              <div className="submit-section">
                <button
                  className="btn-orange"
                  type="submit"
                  disabled={!(formik.isValid && formik.dirty)}
                >
                  Send Instructions
                </button>
              </div>
            </Form>
          );
        }}
      </Formik>

      <p className="text mt-8">
        Having trouble signing into your account? <br />
        Please contact{" "}
        <span>
          <a
            className="link-orange"
            href="https://app.suntendispensary.com/contact/"
          >
            Technical Support.
          </a>
        </span>
      </p>
    </div>
  );
};

export default ForgotLogin;
